<template>
  <div
    v-if="showSubMenu"
    class="m-edition-section-content-info-submenu m-edition-section-content-info-submenu-academy"
  >
    <ul>
      <li>
        <router-link
          :class="[$t('mEditionMenu.academy.users.children.profile.children.account.subitem') === $route.params.subitem
              ? 'submenu-item-active submenu-item-active-academy'
              : '']"
          :to="`/${$t('rPaths.academy')}/${$t('mEditionMenu.academy.users.subject')}/${$route.params.id}/${$t('mEditionMenu.academy.users.children.profile.subedition')}/${$t('mEditionMenu.academy.users.children.profile.children.account.subitem')}`"
        >
          Datos Personales
        </router-link>
      </li>
      <li>
        <router-link
          :class="[$t('mEditionMenu.academy.users.children.profile.children.assets.subitem') === $route.params.subitem
                ? 'submenu-item-active submenu-item-active-academy'
                : '']"
          :to="`/${$t('rPaths.academy')}/${$t('mEditionMenu.academy.users.subject')}/${$route.params.id}/${$t('mEditionMenu.academy.users.children.profile.subedition')}/${$t('mEditionMenu.academy.users.children.profile.children.assets.subitem')}`"
        >
          Cursos
        </router-link>
      </li>
      <li>
        <router-link
          :class="[$t('mEditionMenu.academy.users.children.profile.children.maps.subitem') === $route.params.subitem
                ? 'submenu-item-active submenu-item-active-academy'
                : '']"
          :to="`/${$t('rPaths.academy')}/${$t('mEditionMenu.academy.users.subject')}/${$route.params.id}/${$t('mEditionMenu.academy.users.children.profile.subedition')}/${$t('mEditionMenu.academy.users.children.profile.children.maps.subitem')}`"
        >
          Mapas
        </router-link>
      </li>
      <li>
        <router-link
          :class="[$t('mEditionMenu.academy.users.children.profile.children.sales.subitem') === $route.params.subitem
            || $t('mEditionMenu.academy.users.children.profile.children.salesRecord.subitem') === $route.params.subitem
                ? 'submenu-item-active submenu-item-active-academy'
                : '']"
          :to="`/${$t('rPaths.academy')}/${$t('mEditionMenu.academy.users.subject')}/${$route.params.id}/${$t('mEditionMenu.academy.users.children.profile.subedition')}/${$t('mEditionMenu.academy.users.children.profile.children.sales.subitem')}`"
        >
          Historial de Pagos
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAcademyUsersProfileSubMenu',
  data () {
    return {
      perfil: {},
      showSubMenu: false
    }
  },

  created () {
    this.readAcademiaPerfilActor()
  },

  methods: {
    readAcademiaPerfilActor () {
      this.$store.commit('unsetAcademyLoadingSubmenu')
      // TODO: Modificar nombre de endpoint desde BE y FE
      this.$services
        .read('academia', 'readAcademiaPerfilActor', {}, [
          this.$store.getters.getAcademyData.id,
          this.$route.params.id
        ])
        .then((response) => {
          this.perfil = Object.assign({}, response.data)
          this.perfil.actores.find((actores) => actores.tipo === 0) ? this.showSubMenu = true : this.showSubMenu = false
          this.$store.commit('setAcademyLoadingSubmenu', false)
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>
